<div class="page-container loadable" [class.loading]="isLoading">
    <app-header [title]="'time-off-v3.general-settings-edit.header'" [back]="true"> </app-header>

    <app-general-settings-edit-card
        [selectedBackupApprover]="selectedBackupApprover"
        [timeOffVisibility]="timeOffVisibility"
        [timeOffBalanceDateToday]="timeOffBalanceDateToday"
        [activeAdmins]="activeAdmins"
        (onUpdateBackupApprover)="onUpdateBackupApprover($event)"
        (onTimeOffVisibilityChange)="timeOffVisibility = $event"
        (onTimeOffBalanceDateTodayChange)="timeOffBalanceDateToday = $event"
    ></app-general-settings-edit-card>

    <div class="flex align-items-center justify-end">
        <ui-button (click)="onRedirect()">{{ 'cancel' | translate }}</ui-button>
        <ui-button (click)="onSave()" type="primary"> {{ 'save' | translate }}</ui-button>
    </div>
</div>
